import ScalarSearchResultItem_vue_vue_type_script_setup_true_lang_default from "./ScalarSearchResultItem.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSearchResults/ScalarSearchResultItem.vue
var ScalarSearchResultItem_default = ScalarSearchResultItem_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSearchResultItem_default as default };

//# sourceMappingURL=ScalarSearchResultItem.vue.js.map